// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"ConfirmCheckbox_checkboxContainer__vfBF_","checkbox":"ConfirmCheckbox_checkbox__uZWhj","checkboxText":"ConfirmCheckbox_checkboxText__CB8KS"};